import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "../axios";

const useAddPaymentMutation = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (newPayment) => {
      const response = await axios.post("/api/payment", newPayment);
      return response.data;
    },
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries(["payments"]); // refresh payments list
      options.onSuccess?.(data, variables, context); // call custom onSuccess if provided
    },
  });
};

export default useAddPaymentMutation;
